
















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import OperadoraConvenioStore from '@/components/OperadoraConvenio/Store/OperadoraConvenioStore'

@Component
export default class ComponentModalOperadoraGrupoOperadora extends Vue {
  loadSaveOperadoraConvenioOperadora: boolean = false

  get getOperadoraConvenioStore() {
    return getModule(OperadoraConvenioStore, this.$store)
  }

  get loadingSaveOperadoraConvenioOperadora() {
    return this.loadSaveOperadoraConvenioOperadora
  }

  set loadingSaveOperadoraConvenioOperadora(value: boolean) {
    this.loadSaveOperadoraConvenioOperadora = value
  }

  get showModalOperadoraConvenioOperadora() {
    return this.getOperadoraConvenioStore.modal.operadora
  }

  set showModalOperadoraConvenioOperadora(value: boolean) {
    this.getOperadoraConvenioStore.setModal({ name: 'operadora', value })
  }

  $refs!: {
    formOperadoraConvenioOperadora: any
  }

  formOperadoraConvenioOperadoraRules: any = {
    valid: true,
    operadoraNome: [(v: any) => !!v || 'Campo obrigatório.'],
    grupoHospital: [(v: any) => !!v || 'Campo obrigatório.'],
    registroAns: [(v: any) => this.validateRegistroAns(v)],
  }

  validateRegistroAns(value: any) {
    if (!value || value.length === 0) return 'Campo obrigatório.'
    if (value.length > 0 && value.length < 6) return 'Formato inválido.'
    return false
  }

  async saveOperadoraConvenioOperadora() {
    this.loadingSaveOperadoraConvenioOperadora = true

    if (this.$refs.formOperadoraConvenioOperadora.validate()) {
      const response = await this.getOperadoraConvenioStore.backofficeRegulacaoInsertOperadora()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Operadora adicionado com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getOperadoraConvenioStore.getOperadoraConvenio(this.getOperadoraConvenioStore.hospitalId)
        await this.getOperadoraConvenioStore.getConvenioOperadoras(this.getOperadoraConvenioStore.hospitalId)
        this.showModalOperadoraConvenioOperadora = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao criar a operadora. ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOperadoraConvenioOperadora = false
  }

  @Watch('showModalOperadoraConvenioOperadora')
  onChangeShowModalOperadoraConvenioOperadora(value: boolean) {
    if (!value) {
      this.getOperadoraConvenioStore.clearOperadoraConvenioOperadora()
      this.$refs.formOperadoraConvenioOperadora.resetValidation()
    }
  }
}
